import { render, staticRenderFns } from "./image-editor.vue?vue&type=template&id=8e4dbf9c&scoped=true"
import script from "./image-editor.ts?vue&type=script&lang=ts&external"
export * from "./image-editor.ts?vue&type=script&lang=ts&external"
import style0 from "./image-editor.less?vue&type=style&index=0&id=8e4dbf9c&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e4dbf9c",
  null
  
)

export default component.exports